export default "__VITE_ASSET__1dbecd97__"